import { render } from "./product-banner-two.vue?vue&type=template&id=25d10040&scoped=true"
import script from "./product-banner-two.vue?vue&type=script&lang=js"
export * from "./product-banner-two.vue?vue&type=script&lang=js"

import "./product-banner-two.vue?vue&type=style&index=0&id=25d10040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d10040"]])

export default __exports__